export const GET_LAYOUT = "GET_LAYOUT";
export const GET_RECOMMEND = "GET_RECOMMEND";
export const GET_HOME_CAROUSELS = "GET_HOME_CAROUSELS";
export const GET_STATIC_PATHS = "GET_STATIC_PATHS";